export default "__VITE_ASSET__NrEf7ytH__"